import React, { useEffect, useCallback, useState } from 'react'
import { Link } from 'react-router-dom'
import ReactCookieConsent, { Cookies, getCookieConsentValue } from 'react-cookie-consent'

import { routes } from '../../constants/routes'

const _paq = window._paq || []

const dataLayer = window.dataLayer || []
function myGTag() {
    dataLayer.push(arguments)
}

const CookieConsent = () => {
    const [hasWaited, setHasWaited] = useState(false)
    const [isResolved, setIsResolved] = useState(false)

    useEffect(() => {
        setTimeout(() => {
            setHasWaited(true)
        }, 2000)
    }, [])

    useEffect(() => {
        // look for url params
        const urlParams = new URLSearchParams(window.location.search)
        const wonwSrcParam = urlParams.get('wonwSrc')
        if (wonwSrcParam) {
            Cookies.set('wonwSrc', wonwSrcParam, { expires: 365 })
        }
    }, [])

    const COOKIE_NAME = 'hsrwConsentCookie'
    const cookieExists = getCookieConsentValue(COOKIE_NAME)
    // if cookie not equal to undefined, then set isResolved to true
    useEffect(() => {
        if (cookieExists !== undefined) {
            setIsResolved(true)
        } else if (_paq) {
            _paq.push(['HeatmapSessionRecording::disable'])
        }
    }, [cookieExists])

    const handleAcceptCookieConsent = useCallback(() => {
        const consentMode = 'granted'
        const consent = {
            ad_storage: consentMode,
            analytics_storage: consentMode,
            ad_user_data: consentMode,
            ad_personalization: consentMode
        }

        myGTag('consent', 'update', consent)
        _paq.push(['rememberCookieConsentGiven'])
        _paq.push(['setConsentGiven'])
        _paq.push(['HeatmapSessionRecording::enable'])

        setIsResolved(true)
    }, [])

    useEffect(() => {
        const isConsent = getCookieConsentValue(COOKIE_NAME)
        if (isConsent === 'true') {
            handleAcceptCookieConsent()
        }
    }, [handleAcceptCookieConsent])

    const handleDeclineCookieConsent = () => {
        const consentMode = 'denied'
        // analytics storage is still granted as we are only blocking advertising cookies, not analytics cookies, when user declines consent
        const consent = {
            ad_storage: consentMode,
            analytics_storage: 'granted',
            ad_user_data: consentMode,
            ad_personalization: consentMode
        }

        myGTag('consent', 'update', consent)
        Cookies.remove('_ga')
        Cookies.remove('_gat')
        Cookies.remove('_gid')
        _paq.push(['forgetCookieConsentGiven'])
        _paq.push(['deleteCookies'])
        _paq.push(['HeatmapSessionRecording::disable'])
        setIsResolved(true)
    }

    const handleOverlayClick = () => {
        // shake the cookie-consent-container div
        const cookieConsentContainer = document.querySelector('.cookie-consent-container')
        if (cookieConsentContainer) {
            cookieConsentContainer.classList.add('shake')
            setTimeout(() => {
                cookieConsentContainer.classList.remove('shake')
            }, 500)
        }
    }

    return (
        <>
            {!isResolved &&
                <div className={`cookie-consent-overlay ${hasWaited ? 'active' : ''}`} onClick={handleOverlayClick} />
            }
            <ReactCookieConsent
                location="bottom"
                enableDeclineButton
                declineButtonText="Reject Cookies"
                buttonText="Accept Cookies"
                cookieName={COOKIE_NAME}
                disableStyles={true}
                buttonClasses="button-classes"
                containerClasses={`cookie-consent-container ${hasWaited ? 'active' : ''}`}
                contentClasses="content-wrapper"
                expires={365}
                onAccept={handleAcceptCookieConsent}
                onDecline={handleDeclineCookieConsent}
            >
                <h2>Cookies Consent</h2>
                This site uses cookies to improve user experience.
                Cookies track anonymized data that are analyzed to enable ongoing enhancements.
                You can find out more in our <Link to={routes.termsOfService.path}>terms of service</Link>, <Link to={routes.privacyPolicy.path}>privacy policy</Link> and <Link to={routes.cookiePolicy.path}>cookie policy</Link>.
            </ReactCookieConsent>
        </>
    )
}

export default CookieConsent
